import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export default function Modal({ open, onClose, children }) {
  const modalRef = useRef(null);
  const backdropRef = useRef(null);

  // Gestion du scroll lock
  useEffect(() => {
    if (open) {
      // Empêcher le scroll du body
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";

      // Focus sur la modal pour l'accessibilité
      if (modalRef.current) {
        modalRef.current.focus();
      }
    } else {
      // Rétablir le scroll
      document.body.style.overflow = "unset";
      document.body.style.position = "static";
      document.body.style.width = "auto";
    }

    // Cleanup au démontage
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.position = "static";
      document.body.style.width = "auto";
    };
  }, [open]);

  // Fermeture avec la touche Escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && open) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [open, onClose]);

  // Fermeture en cliquant sur le backdrop
  const handleBackdropClick = (e) => {
    if (e.target === backdropRef.current) {
      onClose();
    }
  };

  if (!open) return null;

  return createPortal(
    <div
      ref={backdropRef}
      className="modal-backdrop-mobile animate-modal-backdrop"
      onClick={handleBackdropClick}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999,
        display: "flex",
        visibility: "visible",
        opacity: 1,
      }}
    >
      <div
        ref={modalRef}
        className="modal-content-mobile animate-modal-content"
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        style={{
          position: "relative",
          zIndex: 100000,
          display: "block",
          visibility: "visible",
          opacity: 1,
        }}
      >
        <button
          onClick={onClose}
          className="modal-mobile-fix absolute top-4 right-4 text-gray-400 hover:text-pink-600 text-2xl font-bold transition-colors duration-200 hover:bg-gray-100 w-8 h-8 flex items-center justify-center rounded-full"
          aria-label="Fermer la modal"
        >
          ×
        </button>
        {children}
      </div>
    </div>,
    document.body
  );
}
